<lib-cart></lib-cart>

<!-- <hr />
<colmec-user-cartlist-autoadded></colmec-user-cartlist-autoadded> -->

<div class="row">
  <div class="col-12 text-right">
    <colmec-cart-summary></colmec-cart-summary>
  </div>
</div>
